export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_1.4-9426fc4ee586d778a28953e4aa3e453f.svg";